import React from "react";
import { useEffect, useState } from "react";
import { Container, Card } from "react-bootstrap";
import previousImg from "../assets/img/previos.png";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Image from "react-bootstrap/Image";
import Cookies from "js-cookie";
import Button from "react-bootstrap/Button";
import avatar from "../assets/img/default.png";
import "./Tournament.css";

export default function TournamentDetailsCard() {
  const [tournament, setTournament] = useState();
  const [isLoggedIn, setIsLoggenIn] = useState(false);
  const [loader, setLoader] = useState(false);

  function checkWinners() {
    if (
      (tournament.winners[0] &&
        tournament.winners[1] &&
        tournament.winners[2] &&
        tournament.winners[0].teamName.length > 0) ||
      tournament.winners[1].teamName.length > 0 ||
      tournament.winners[2].teamName.length > 0
    ) {
      return true;
    }
    return false;
  }

  useEffect(() => {
    const token = Cookies.get("token");
    if (token) {
      setIsLoggenIn(true);
    } else {
      setIsLoggenIn(false);
    }
  }, []);

  const { tid } = useParams();
  useEffect(() => {
    setLoader(true);
    async function getTournament() {
      await axios
        .get(`https://vickygaming.onrender.com/api/v1/tournaments/${tid}`, {
          returnSecureToken: true,
        })
        .then((response) => {
          // console.log(response.data.tournament);
          setTournament(response.data.tournament);
          setLoader(false);
        })
        .catch((error) => {
          console.log(error);
        });
    }
    if (tid) {
      getTournament();
    }
  }, [tid]);
  const navigate = useNavigate();
  function handleDate(date) {
    const d = new Date(date);
    return d.getDate();
  }
  function handleMonth(date) {
    const d = new Date(date);
    // const month = date.toLocaleString('default', { month: 'long' });
    return d.toLocaleString("default", { month: "long" });
  }
  function handleYear(date) {
    const d = new Date(date);
    return d.getFullYear();
  }
  function handleNavigation() {
    navigate("/tournament");
  }
  return (
    <Container className="mt-4">
      <div
        className="previos mb-3"
        style={{ cursor: "pointer" }}
        onClick={handleNavigation}
      >
        <h1>
          {" "}
          <span>
            <img
              src={previousImg}
              alt="icon"
              style={{ height: "30px", width: "30px" }}
            />
          </span>{" "}
          All Tournaments
        </h1>
      </div>
      {isLoggedIn && (
        <div className="addbutton mb-5">
          <Button
            className="tbutton"
            onClick={() => navigate(`/updateTournament/${tournament._id}`)}
          >
            Update Tournament
          </Button>
        </div>
      )}
      <Card
        className="mb-4"
        style={{ background: "rgb(34, 34, 34)", color: "#fff" }}
      >
        <Card.Body className="p-4">
          <Card.Title className="text-center mb-3" style={{ fontSize: "30px" }}>
            Tournament Details
          </Card.Title>
          {loader && (
            <div className="d-flex align-items-center justify-content-center text-center mt-4 mb-4">
              {" "}
              <div className="wrapper">
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="circle"></div>
                <div className="shadow"></div>
                <div className="shadow"></div>
                <div className="shadow"></div>
              </div>
            </div>
          )}
          {tournament && (
            <>
              <h1 style={{ fontSize: "20px" }}>
                {tournament.seasonName.toUpperCase()}
              </h1>
              <p className="mt-3" style={{ fontSize: "18px" }}>
                Date and Time :{" "}
                <span style={{ color: "#ffffffc8" }}>
                  {handleDate(tournament.date)} {handleMonth(tournament.date)}{" "}
                  {handleYear(tournament.date)} | {tournament.time}
                </span>{" "}
              </p>
              <p style={{ fontSize: "18px", marginBottom: "5px" }}>Rules</p>
              <ol>
                {tournament.rules.map((rule, id) => (
                  <li key={id} style={{ color: "#ffffffc8", fontSize: "18px" }}>
                    {rule}
                  </li>
                ))}
              </ol>
              <p style={{ fontSize: "18px" }}>
                Prize :{" "}
                <span style={{ color: "#ffffffc8" }}>
                  {tournament.prizeDetails}
                </span>
              </p>
              {checkWinners() && (
                <p style={{ fontSize: "18px" }}>Winners Details </p>
              )}
              {tournament.winners.map(function (winner, id) {
                if (winner.teamName.length > 0) {
                  return (
                    <div
                      className="mb-2"
                      key={id}
                      style={{ fontSize: "18px", color: "#ffffffc8" }}
                    >
                      <p style={{ marginBottom: "5px" }}>
                        Prize {winner.position}
                      </p>
                      <Image
                        src={winner.teamLogo || avatar}
                        style={{ height: "30px", width: "30px" }}
                        roundedCircle
                      />
                      <p className="mt-1" style={{ marginBottom: "2px" }}>
                        {winner.teamName}
                      </p>
                      <p>
                        Team Members :{" "}
                        {winner.teamMembers.map((member, mid) => (
                          <span key={mid}>
                            {member}{" "}
                            {mid < winner.teamMembers.length - 1 && <>,</>}
                          </span>
                        ))}
                      </p>
                    </div>
                  );
                } else {
                  return <></>;
                }
              })}
              {tournament.overallPerformer.length > 0 && (
                <p style={{ fontSize: "20px" }}>
                  Overall Performer :{" "}
                  <span style={{ color: "#ffffffc8" }}>
                    {tournament.overallPerformer}
                  </span>
                </p>
              )}
              {tournament.bestAttacker.length > 0 && (
                <p style={{ fontSize: "20px" }}>
                  Best Attacker :{" "}
                  <span style={{ color: "#ffffffc8" }}>
                    {tournament.bestAttacker}
                  </span>
                </p>
              )}
            </>
          )}

          {/* <Card.Link href="#">Another Link</Card.Link> */}
        </Card.Body>
      </Card>
    </Container>
  );
}
